import * as Sentry from '@sentry/browser'

Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN })

export const logInfo = (message, severity = 'info') => {
  Sentry.captureMessage(message, severity)
}

export default Sentry